
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"92","height":"93","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M77.703 17.781H14.797c-4.729 0-8.578 3.85-8.578 8.578v40.032c0 4.728 3.85 8.578 8.578 8.578h62.906c4.729 0 8.578-3.85 8.578-8.578V26.359c0-4.728-3.85-8.578-8.578-8.578zm2.86 48.61a2.863 2.863 0 01-2.86 2.859H14.797a2.863 2.863 0 01-2.86-2.86V26.36a2.863 2.863 0 012.86-2.86h62.906a2.863 2.863 0 012.86 2.86v40.03z","fill":"#fff"}}),_c('path',{attrs:{"d":"M32.668 45.96c4.843 0 8.778-3.939 8.778-8.778 0-4.843-3.936-8.778-8.778-8.778-4.843 0-8.778 3.94-8.778 8.778 0 4.843 3.935 8.778 8.778 8.778zm0-11.839a3.063 3.063 0 013.06 3.06 3.063 3.063 0 01-3.06 3.06 3.063 3.063 0 01-3.06-3.06 3.063 3.063 0 013.06-3.06zM37.014 48.226H28.32c-4.728 0-8.578 3.85-8.578 8.578v4.682a2.859 2.859 0 105.719 0v-4.682a2.863 2.863 0 012.86-2.86h8.696a2.863 2.863 0 012.859 2.86v4.682a2.859 2.859 0 105.719 0v-4.682c-.004-4.729-3.85-8.578-8.582-8.578zM73.415 54.953H56.259a2.859 2.859 0 100 5.719h17.156a2.859 2.859 0 100-5.719zM73.415 43.516H56.259a2.859 2.859 0 100 5.718h17.156a2.859 2.859 0 100-5.718zM73.415 32.078H56.259a2.859 2.859 0 100 5.719h17.156a2.859 2.859 0 100-5.719z","fill":"#fff"}})])
          )
        }
      }
    